"use client";

import Link from "next/link";

import { Button, Card, CardContent, CardHeader, CardTitle } from "@stocks/ui";

import { useBom, useProduct } from "@/entities/order";
import { ProductOptions } from "@/features/order/product-option";
import { BomEditor } from "@/features/order/save-bom";
import { ProductEditForm } from "@/features/order/update-product";

/** 제품 상세 — 기본 정보 수정, 색상/사이즈 옵션, BOM(한 벌당 소요량) */
export const ProductDetail = ({ id }: { id: string }) => {
  const { data: product, isLoading, isError } = useProduct(id);
  const { data: bom, isLoading: bomLoading } = useBom(id);

  if (isLoading) return <p className='text-muted-foreground'>불러오는 중…</p>;
  if (isError || !product)
    return <p className='text-destructive'>제품을 찾을 수 없습니다.</p>;

  return (
    <div className='flex max-w-5xl flex-col gap-6'>
      <div className='flex items-center justify-between'>
        <p className='text-sm text-muted-foreground'>{product.code}</p>
        <Button asChild variant='outline'>
          <Link href='/orders/products'>제품 목록</Link>
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>기본 정보</CardTitle>
        </CardHeader>
        <CardContent>
          <ProductEditForm product={product} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>색상 · 사이즈 옵션</CardTitle>
        </CardHeader>
        <CardContent>
          <ProductOptions productId={product.id} options={product.options} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>BOM (한 벌당 기준 소요량)</CardTitle>
        </CardHeader>
        <CardContent>
          {bomLoading ? (
            <p className='text-muted-foreground'>BOM 을 불러오는 중…</p>
          ) : (
            <BomEditor
              productId={product.id}
              options={product.options.filter((o) => o.isActive)}
              bom={bom}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
};
